import { OrderStatus } from "./inde_menu";

// Order Status Validation Utility (can be moved to a separate file)
export const validateOrderStatusTransition = (currentStatus: OrderStatus, newStatus: OrderStatus): boolean => {
    const validTransitions: Record<OrderStatus, OrderStatus[]> = {
        'pending': ['confirmed', 'cancelled', 'rejected'],
        'confirmed': ['preparing', 'cancelled'],
        'preparing': ['ready', 'cancelled'],
        'ready': ['served', 'cancelled'],
        'served': ['completed', 'cancelled'],
        'completed': [], // No transitions from completed
        'cancelled': [], // No transitions from cancelled
        'rejected': [], // No transitions from rejected
    };

    return validTransitions[currentStatus]?.includes(newStatus) || false;
};